import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-gemini-tip-modal',
  templateUrl: './gemini-tip-modal.component.html',
  styleUrls: ['./gemini-tip-modal.component.scss'],
})
export class GeminiTipModalComponent {}
